/**
 * Shared status badge icons — Visitor / Appointment / Disposition.
 * Icons follow visitor-status-badge--* classes from getClosingStatusBadgeClass.
 */

export function getStatusBadgeIconClass(badgeClass = "") {
  const c = String(badgeClass || "");
  if (c.includes("cancelled")) return "fa fa-exclamation-circle";
  if (c.includes("checkedin")) return "fa fa-check-circle";
  if (c.includes("booking")) return "fa fa-check-circle";
  if (c.includes("followup")) return "fa fa-phone";
  if (c.includes("reschedule")) return "fa fa-clock-o";
  if (c.includes("revisit")) return "fa fa-refresh";
  // Upcoming Revisit / Ready to Visit / Ready to Book
  if (c.includes("ready")) return "fa fa-refresh";
  if (c.includes("new")) return "fa fa-clock-o";
  if (c.includes("unqualified")) return "fa fa-times-circle";
  if (c.includes("qualified")) return "fa fa-check-circle";
  return "fa fa-info-circle";
}

/** Lead status (visitor list/detail) → icon by lead_status code. */
export function getVisitorLeadStatusIconClass(leadStatus) {
  const status = Number(leadStatus);
  if (status === 1) return "fa fa-clock-o";
  if (status === 2) return "fa fa-phone";
  if (status === 3 || status === 7) return "fa fa-refresh";
  if (status === 4 || status === 5) return "fa fa-check-circle";
  if (status === 6 || status === 8) return "fa fa-exclamation-circle";
  return "fa fa-info-circle";
}
